module.exports = __webpack_public_path__ + "img/hav_yes.fe67569f.png";